import * as Yup from 'yup'

export const residentStepFormSchema = Yup.object().shape({
  residentStep: Yup.string().required('Selecciona a un residente'),
})



// WEBPACK FOOTER //
// ./src/views/RecommendationsForms/ResidenceForm/ResidentStep/ResidentStep.validator.ts